import * as React from "react";

import { cn } from "@/lib/utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        "flex min-h-20 w-full rounded-lg border border-border bg-surface-elevated px-3 py-2 text-sm text-foreground transition-colors",
        "placeholder:text-text-dim",
        "focus-visible:border-primary-mid focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-mid",
        "disabled:cursor-not-allowed disabled:opacity-60",
        "read-only:cursor-default read-only:opacity-75",
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";
